import logo1987 from "../../assets/img/ple/survivor-series/logos/1987-1988.png";
import logo1989 from "../../assets/img/ple/survivor-series/logos/1989-1993.png";
import logo1994 from "../../assets/img/ple/survivor-series/logos/1994.png";
import logo1995 from "../../assets/img/ple/survivor-series/logos/1995.png";
import logo1996 from "../../assets/img/ple/survivor-series/logos/1996.png";
import logo1997 from "../../assets/img/ple/survivor-series/logos/1997.png";
import logo1998 from "../../assets/img/ple/survivor-series/logos/1998.png";
import logo1999 from "../../assets/img/ple/survivor-series/logos/1999.png";
import logo2000 from "../../assets/img/ple/survivor-series/logos/2000.png";
import logo2001 from "../../assets/img/ple/survivor-series/logos/2001.png";
import logo2002 from "../../assets/img/ple/survivor-series/logos/2002.png";
import logo2003 from "../../assets/img/ple/survivor-series/logos/2003.png";
import logo2004 from "../../assets/img/ple/survivor-series/logos/2004.png";
import logo2005 from "../../assets/img/ple/survivor-series/logos/2005.png";
import logo2006 from "../../assets/img/ple/survivor-series/logos/2006.png";
import logo2007 from "../../assets/img/ple/survivor-series/logos/2007.png";
import logo2008 from "../../assets/img/ple/survivor-series/logos/2008.png";
import logo2009 from "../../assets/img/ple/survivor-series/logos/2009.png";
import logo2010 from "../../assets/img/ple/survivor-series/logos/2010.png";
import logo2011 from "../../assets/img/ple/survivor-series/logos/2011.png";
import logo2012 from "../../assets/img/ple/survivor-series/logos/2012.png";
import logo2013 from "../../assets/img/ple/survivor-series/logos/2013.png";
import logo2014 from "../../assets/img/ple/survivor-series/logos/2014.png";
import logo2015 from "../../assets/img/ple/survivor-series/logos/2015.png";
import logo2016 from "../../assets/img/ple/survivor-series/logos/2016.png";
import logo2017 from "../../assets/img/ple/survivor-series/logos/2017.png";
import logo2018 from "../../assets/img/ple/survivor-series/logos/2018.png";
import logo2019 from "../../assets/img/ple/survivor-series/logos/2019.png";
import logo2020 from "../../assets/img/ple/survivor-series/logos/2020.png";
import logo2021 from "../../assets/img/ple/survivor-series/logos/2021.png";
import logo2022 from "../../assets/img/ple/survivor-series/logos/2022-2023.png";
import logo2024 from "../../assets/img/ple/survivor-series/logos/2024.png";
import logo2025 from "../../assets/img/ple/survivor-series/logos/2025.png";

import winner1 from "../../assets/img/ple/survivor-series/winners/Team André the Giant.png";
import winner2 from "../../assets/img/ple/survivor-series/winners/Team Mega Powers.png";
import winner3 from "../../assets/img/ple/survivor-series/winners/Team Ultimate Warriors.png";
import winner4 from "../../assets/img/ple/survivor-series/winners/Team Hulk Hogan.png";
import winner5 from "../../assets/img/ple/survivor-series/winners/Team Legion of Doom.png";
import winner6 from "../../assets/img/ple/survivor-series/winners/Team Nasty Boys.png";
import winner7 from "../../assets/img/ple/survivor-series/winners/Team All-Americans.png";
import winner8 from "../../assets/img/ple/survivor-series/winners/The Million Dollar Team.png";
import winner9 from "../../assets/img/ple/survivor-series/winners/Team Shawn Michaels.png";
import winner10 from "../../assets/img/ple/survivor-series/winners/Team Marc Mero.png";
import winner11 from "../../assets/img/ple/survivor-series/winners/Team Road Warriors.png";
import winner12 from "../../assets/img/ple/survivor-series/winners/Team Val Venis.png";
import winner13 from "../../assets/img/ple/survivor-series/winners/Team Radicalz.png";
import winner14 from "../../assets/img/ple/survivor-series/winners/Team WWF.png";
import winner15 from "../../assets/img/ple/survivor-series/winners/Team Bischoff.png";

export const survivorSeriesDetail = {
  id: "survivor-series",
  title: "Survivor Series",
  subtitle: "Explore winners and event editions in a dedicated event view.",
  tabs: [
    {
      id: "winners",
      label: "Winners",
      variant: "survivor-series",
      items: [
        {
          id: "ss-winner1",
          title: "Team André the Giant",
          description: "Traditional S. Series Elimination Match 1987",
          imgUrl: winner1,
        },
        {
          id: "ss-winner2",
          title: "Team Mega Powers",
          description: "Traditional S. Series Elimination Match 1988",
          imgUrl: winner2,
        },
        {
          id: "ss-winner3",
          title: "Team Ultimate Warriors",
          description: "Traditional S. Series Elimination Match 1989",
          imgUrl: winner3,
        },
        {
          id: "ss-winner4",
          title: "Team Hulk Hogan",
          description: "Traditional S. Series Elimination Match 1990",
          imgUrl: winner4,
        },
        {
          id: "ss-winner5",
          title: "Team Legion of Doom",
          description: "Traditional S. Series Elimination Match 1991",
          imgUrl: winner5,
        },
        {
          id: "ss-winner6",
          title: "Team Nasty Boys",
          description: "Traditional S. Series Elimination Match 1992",
          imgUrl: winner6,
        },
        {
          id: "ss-winner7",
          title: "Team All-Americans",
          description: "Traditional S. Series Elimination Match 1993",
          imgUrl: winner7,
        },
        {
          id: "ss-winner8",
          title: "The Million Dollar Team",
          description: "Traditional S. Series Elimination Match 1994",
          imgUrl: winner8,
        },
        {
          id: "ss-winner9",
          title: "Team Shawn Michaels",
          description: "Traditional S. Series Elimination Match 1995",
          imgUrl: winner9,
        },
        {
          id: "ss-winner10",
          title: "Team Marc Mero",
          description: "Traditional S. Series Elimination Match 1996",
          imgUrl: winner10,
        },
        {
          id: "ss-winner11",
          title: "Team Road Warriors",
          description: "Traditional S. Series Elimination Match 1997",
          imgUrl: winner11,
        },
        {
          id: "ss-winner12",
          title: "Team Val Venis",
          description: "Traditional S. Series Elimination Match 1998",
          imgUrl: winner12,
        },
        {
          id: "ss-winner13",
          title: "Team Radicalz",
          description: "Traditional S. Series Elimination Match 1999",
          imgUrl: winner13,
        },
        {
          id: "ss-winner14",
          title: "Team WWF",
          description: "Traditional S. Series Elimination Match 2000",
          imgUrl: winner14,
        },
        {
          id: "ss-winner15",
          title: "Team Bischoff",
          description: "Traditional S. Series Elimination Match 2001",
          imgUrl: winner15,
        },
      ],
    },
    {
      id: "logos",
      label: "Editions",
      variant: "survivor-series",
      items: [
        {
          id: "survivor-series-logo-1987",
          title: "Survivor Series",
          description: "The Biggest Event Since WrestleMania III! 1987",
          imgUrl: logo1987,
        },
        {
          id: "survivor-series-logo-1988",
          title: "Survivor Series",
          description: "Teams of Five Strive to Survive 1988",
          imgUrl: logo1987,
        },
        {
          id: "survivor-series-logo-1989",
          title: "Survivor Series",
          description: "The WWF Thanksgiving Night Tradition! 1989",
          imgUrl: logo1989,
        },
        {
          id: "survivor-series-logo-1990",
          title: "Survivor Series",
          description: "1990",
          imgUrl: logo1989,
        },
        {
          id: "survivor-series-logo-1991",
          title: "Survivor Series",
          description: "The Gravest Challenge 1991",
          imgUrl: logo1989,
        },
        {
          id: "survivor-series-logo-1992",
          title: "Survivor Series",
          description: "1992",
          imgUrl: logo1989,
        },
        {
          id: "survivor-series-logo-1993",
          title: "Survivor Series",
          description: "The Thanksgiving Tradition All Americans Wait For! 1993",
          imgUrl: logo1989,
        },
        {
          id: "survivor-series-logo-1994",
          title: "Survivor Series",
          description: "It's Time to Meet Your Maker... 1994",
          imgUrl: logo1994,
        },
        {
          id: "survivor-series-logo-1995",
          title: "Survivor Series",
          description: "Teams of Federation Superstars Battle it out! 1995",
          imgUrl: logo1995,
        },
        {
          id: "survivor-series-logo-1996",
          title: "Survivor Series",
          description: "Back to Attack 1996",
          imgUrl: logo1996,
        },
        {
          id: "survivor-series-logo-1997",
          title: "Survivor Series",
          description: "Gang Rulz 1997",
          imgUrl: logo1997,
        },
        {
          id: "survivor-series-logo-1998",
          title: "Survivor Series",
          description: "Deadly game 1998",
          imgUrl: logo1998,
        },
        {
          id: "survivor-series-logo-1999",
          title: "Survivor Series",
          description: "1999",
          imgUrl: logo1999,
        },
        {
          id: "survivor-series-logo-2000",
          title: "Survivor Series",
          description: "The Rules Have Changed 2000",
          imgUrl: logo2000,
        },
        {
          id: "survivor-series-logo-2001",
          title: "Survivor Series",
          description: "Winner Take All! 2001",
          imgUrl: logo2001,
        },
        {
          id: "survivor-series-logo-2002",
          title: "Survivor Series",
          description: "2002",
          imgUrl: logo2002,
        },
        {
          id: "survivor-series-logo-2003",
          title: "Survivor Series",
          description: "A Fall from Grace 2003",
          imgUrl: logo2003,
        },
        {
          id: "survivor-series-logo-2004",
          title: "Survivor Series",
          description: "2004",
          imgUrl: logo2004,
        },
        {
          id: "survivor-series-logo-2005",
          title: "Survivor Series",
          description: "The Beginning of the End 2005",
          imgUrl: logo2005,
        },
        {
          id: "survivor-series-logo-2006",
          title: "Survivor Series",
          description: "2006",
          imgUrl: logo2006,
        },
        {
          id: "survivor-series-logo-2007",
          title: "Survivor Series",
          description: "2007",
          imgUrl: logo2007,
        },
        {
          id: "survivor-series-logo-2008",
          title: "Survivor Series",
          description: "Spoilin' for a Fight 2008",
          imgUrl: logo2008,
        },
        {
          id: "survivor-series-logo-2009",
          title: "Survivor Series",
          description: "2009",
          imgUrl: logo2009,
        },
        {
          id: "survivor-series-logo-2010",
          title: "Survivor Series",
          description: "Will you survive? 2010",
          imgUrl: logo2010,
        },
        {
          id: "survivor-series-logo-2011",
          title: "Survivor Series",
          description: "Never Before. Never Again. 2011",
          imgUrl: logo2011,
        },
        {
          id: "survivor-series-logo-2012",
          title: "Survivor Series",
          description: "Will you survive? 2012",
          imgUrl: logo2012,
        },
        {
          id: "survivor-series-logo-2013",
          title: "Survivor Series",
          description: "2013",
          imgUrl: logo2013,
        },
        {
          id: "survivor-series-logo-2014",
          title: "Survivor Series",
          description: "2014",
          imgUrl: logo2014,
        },
        {
          id: "survivor-series-logo-2015",
          title: "Survivor Series",
          description: "25 Years of Undertaker 2015",
          imgUrl: logo2015,
        },
        {
          id: "survivor-series-logo-2016",
          title: "Survivor Series",
          description: "Fantasy Warfare Just Got Real 2016",
          imgUrl: logo2016,
        },
        {
          id: "survivor-series-logo-2017",
          title: "Survivor Series",
          description: "2017",
          imgUrl: logo2017,
        },
        {
          id: "survivor-series-logo-2018",
          title: "Survivor Series",
          description: "2018",
          imgUrl: logo2018,
        },
        {
          id: "survivor-series-logo-2019",
          title: "Survivor Series",
          description: "2019",
          imgUrl: logo2019,
        },
        {
          id: "survivor-series-logo-2020",
          title: "Survivor Series",
          description: "2020",
          imgUrl: logo2020,
        },
        {
          id: "survivor-series-logo-2021",
          title: "Survivor Series",
          description: "2021",
          imgUrl: logo2021,
        },
        {
          id: "survivor-series-logo-2022-2023",
          title: "Survivor Series",
          description: "War Games 2022 - 2023",
          imgUrl: logo2022,
        },
        {
          id: "survivor-series-logo-2024",
          title: "Survivor Series",
          description: "War Games Canadá 2024",
          imgUrl: logo2024,
        },
        {
          id: "survivor-series-logo-2025",
          title: "Survivor Series",
          description: "War Games San Diego 2025",
          imgUrl: logo2025,
        },
      ],
    },
  ],
};
